import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ButtonProps,
} from "@chakra-ui/react";
import React from "react";
import { Except } from "type-fest";

export type ButtonGroupItem<T extends string> = {
  value: T;
  label: string;
  buttonProps?: ButtonProps;
};

/**
 * A button group that only allows one button to be selected at a time.
 */
export function SingleSelectButtonGroup<T extends string>({
  options,
  value,
  onChange,
  colorScheme = "primary",
  ...props
}: {
  options: ButtonGroupItem<T>[];
  value: T;
  onChange: (value: T) => void;
} & Except<ButtonGroupProps, "onChange">) {
  return (
    <ButtonGroup {...props}>
      {options.map((option) => {
        const isSelected = option.value === value;

        const styles =
          isSelected ?
            {
              colorScheme,
              backgroundColor: `${colorScheme}.100`,
              borderColor: `${colorScheme}.500`,
              zIndex: 1,
              "aria-pressed": true,
            }
          : {
              colorScheme: "gray",
              "aria-pressed": false,
            };

        return (
          <Button
            key={option.value}
            onClick={() => onChange(option.value)}
            {...styles}
            {...option.buttonProps}
          >
            {option.label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
